import { type CheckboxProps as AntCheckboxProps, Checkbox as AntCheckbox } from 'antd';
import styled, { css } from 'styled-components';
import { CheckboxListItem } from './components/ListItem';
import { getCheckboxStyle } from './utils/getCheckboxStyle';

const { Group } = AntCheckbox;

export enum CheckboxSize {
  Small = 'small',
  Medium = 'medium',
}

export interface CheckboxProps extends AntCheckboxProps {
  size?: CheckboxSize;
}

const StyledCheckbox = styled(AntCheckbox)<CheckboxProps>`
  // NOTE: Center label vertically with checkbox
  span:nth-of-type(2) {
    margin: auto;
    white-space: normal;
  }

${({ theme, size }) => {
  return css`
    font-size: ${theme.typography.fontSize[size === CheckboxSize.Small ? 2 : 3]};
  `;
}}


  ${getCheckboxStyle()}
`;
export function Checkbox(props: CheckboxProps): JSX.Element {
  return <StyledCheckbox {...props} />;
}

Checkbox.Group = Group;
Checkbox.ListItem = CheckboxListItem;
